import React, {Component} from 'react'
import ReactPlayer from 'react-player/lib/players/FilePlayer'
import Settings from '../../Settings'
import {Page, Container169} from './../common/StyledComponents'
import ReactGA from 'react-ga'
import InputRange from 'react-input-range'
import {InputRangeStyle, Button, Controls, SeekContainer, PlayButton, PauseButton, StopButton} from './Components'

export class Video extends Component {
  state = {
    playing: true,
    played: 0,
    duration: 0,
    seeking: false,
  }

  playPause = () => {
    this.setState({playing: !this.state.playing})
  }

  onSeekStart = () => {
    this.setState({seeking: true})
  }

  onSeekChange = value => {
    this.setState({played: value})
  }

  onSeekEnd = value => {
    this.setState({seeking: false})
    this.player.seekTo(value)
  }

  onProgress = state => {
    if (!this.state.seeking) {
      this.setState(state)
    }
  }

  onEnded = () => {
    const {
      match: {
        params: {locale, categoryKey, videoKey},
      },
    } = this.props
    this.props.history.push(`/${locale}/category/${categoryKey}/video/${videoKey}/end`)
  }

  ref = player => {
    this.player = player
  }

  render() {
    const {
      match: {
        params: {categoryKey, videoKey, locale},
      },
    } = this.props
    const category = Settings.categories.find(category => category.key === categoryKey)
    const videoData = category.videos.find(video => video.key === videoKey)
    const {playing, played} = this.state

    ReactGA.event({
      category: 'Video',
      action: 'Play',
      label: `${videoData.label[locale]} from category ${category.label[locale]}`,
    })

    return (
      <Page>
        <Container169>
          {
            <ReactPlayer
              ref={this.ref}
              url={videoData.url[locale]}
              playing={playing}
              width="100%"
              height="100%"
              controls={false}
              onEnded={this.onEnded}
              onProgress={this.onProgress}
            />
          }
        </Container169>
        {Settings.videoControls ? (
          <Controls>
            <Button onClick={this.playPause}>{playing ? <PauseButton /> : <PlayButton />}</Button>
            <Button onClick={this.onEnded}>
              <StopButton />
            </Button>
            <SeekContainer>
              <InputRangeStyle />
              <InputRange
                maxValue={1}
                minValue={0}
                step={0.001}
                value={played}
                onChange={this.onSeekChange}
                onChangeStart={this.onSeekStart}
                onChangeComplete={this.onSeekEnd}
              />
            </SeekContainer>
          </Controls>
        ) : null}
      </Page>
    )
  }
}
